import axios from "axios"

const CuentasBancariasService = {
  getCuentaBancariaById(id: $TSMigrationFixMe) {
    return axios.get(`/cuentaBancaria/${id}`)
  },

  deleteCuentaBancaria(id: $TSMigrationFixMe) {
    return axios.delete(`/cuentaBancaria/${id}`)
  },

  getMovimientosByCuentaBancaria(
    queryParam: $TSMigrationFixMe,
    iban: $TSMigrationFixMe
  ) {
    return axios.get(`/cuentaBancaria/${iban}/movimientos${queryParam}`)
  },
}

export default CuentasBancariasService
